<template>
    <div width="100%">
        <h4><b>FAQ</b></h4>
        <el-table :show-header="false" :data="faqs" style="width:100%" :row-key="getRowKeys" :expand-row-keys="expands" @row-click="rowClick">
                <el-table-column type='expand' width='60px'>
                    <template scope="props">
                        <p v-for="(item,index) in props.row.answer" :key="index" v-html="item"></p>
                    </template>
                </el-table-column>
                <el-table-column type="index">
                </el-table-column>
                <el-table-column  width='740px'>
                    <template slot-scope="scope">
                        <i :class="scope.row.icon"></i>
                        <span style="margin-left: 10px">{{ scope.row.question }}</span>
                    </template>
                </el-table-column>
        </el-table>
        <div style="margin-top:40px">
            <!-- <a href="http://www.searchplusplus.jp/Query.html">問い合わせフォーム</a> -->
            <el-button type="success" @click="$router.push('query')">問い合わせフォーム</el-button>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      expands: [],
      faqs: [{
        id: '1',
        question: 'ダウンロード途中で、「一般的にダウンロードされておらず危険を及ぼす可能性があります」というような警告が出て ダウンロードを中止するように勧告が表示されましたが、どのようにすればいいでしょうか？',
        answer: [
          'この警告はブラウザ自体のセキュリティ の関係上出現してしまうものです。全文検索くんソフトウェア自体はウィルス検査もパスしており、 有害なソフトウェアではございませんので、この警告に対して「継続」と答えれば、ファイルを ダウンロードしていただけます。',
          'Windows 10で実行する場合、「WindowsよりPCが保護されました、Windows SmartScreenは認識されないアプリの起動を停止しました。このアプリを起動すると、 PCに問題が起こる可能性があります。詳細情報」とのメッセージが出たら、Windows10の誤報です、詳細情報をクリックして、実行してください。'
        ]
      }, {
        id: '2',
        question: 'インストールフォルダーについて',
        answer: [
          'インストールフォルダーについて、インストールフォルダーについて、C:\\Program Files, C:\\Program Files(X86)に入れないでください。（権限の問題で動かなくなる可能性がある）',
          'C:\\Program Files\\SearchPlusPlus（✖）',
          'C:\\SearchPlusPlus（〇）',
          'D:\\SearchPlusPlus（〇）',
          'Zip ファイルを展開する際、”展開フされたァイルがありません”のようなエラーメッセージが出た或はZip展開した後 SearchPlusPlus.exe を起動させようと、”Could not find Java SE Environment”のようなエラーメッセージが出た場合、OS のコード設定不正と考えられます。下記質問６)の回答通りにOS のコードを日本語に設定し直すか、全文検索くんのインストールフォルダー名に日本語を使用しないか（例えば： C:\\SearchPlusPlus またはD:\\SearchPlusPlus にインストールする）によって、問題が解決できます。'
        ]
      }, {
        id: '3',
        question: '検索キーワードについて',
        answer: [
          '入力した検索語に対して、キーワードの分析処理（Keyword Parsing）をしてから検索をかけます、検索キーがいずれ存在すれば、そのファイルを検出します。',
          '検索語をダブルクォーテーションで括る場合、上記分析処理をせず、検索語をひとつ検索単位とします、一部の単語だけが存在しているファイルはヒット対象になりません',
          'ですから、人名、地名で検索する場合、ひとつの検索単位として、半角ダブルクォーテーションで括って検索してください。例えば、中村一郎を検索する場合、"中村一郎"で検索欄に記述してください。'
        ]
      }, {
        id: '4',
        question: '社内ネットワーク上のファイルを検索可能ですか',
        answer: [
          '可能です。シェアフォルダをネットワークドライブに割り当てたら、普通に検索できます。',
          'オプション画面のインデックス対象指定画面で割り当て機能があります。'
        ]
      }, {
        id: '5',
        question: '検索キーワードについて',
        answer: [
          '入力した検索語に対して、キーワードの分析処理（Keyword Parsing）をしてから検索をかけます、検索キーがいずれ存在すれば、そのファイルを検出します。'
        ]
      }, {
        id: '6',
        question: 'インデックスデータの自動更新機能がありますか',
        answer: [
          '常駐モードでは、対象フォルダを監視して、変更があれば、対象となるものに対してインデックスデータを自動更新します。'
        ]
      }, {
        id: '7',
        question: '文字化けの防止',
        answer: [
          'コントロールパネルで「形式」・「現在の場所」・「現在のシステムロケール」以上３か所を「日本語」・「日本」に設定してください。'
        ]
      }, {
        id: '8',
        question: 'サブフォルダを検索対象外とする機能がありますか',
        answer: [
          'オプション画面でファイルの拡張子設定により特定タイプのファイルを排除することが可能です。同じく、フォルダ選択画面でサブフォルダの排除も可能です'
        ]
      }, {
        id: '9',
        question: 'ホットキーがありますか',
        answer: [
          'ホットキーで検索のメーン画面を呼び出すことがあります。ホットキーについて、「オプション」画面で設定可能です。',
          'しかし、Adobe Readerの保護モード設定によって、ホットキーがブロックされた場合があります。',
          '保護モードを外す方法はAdobe Readerのバージョンによって違います',
          'Reader X以下では「編集」メニュー>「環境設定」の「一般」タブを選んで、「起動時に保護モードを有効にする」をオフにする。',
          'Reader XIでは「編集」メニュー>「環境設定」の「セキュリティ（拡張）」タブを選んで、「サンドボックスによる保護」領域で、「起動時に保護モードを有効にする」をオフにします。'
        ]
      }, {
        id: '10',
        question: 'インストール・アンインストール機能がありますか',
        answer: [
          '全文検索くん標準版ではレジストリの変更がないくて、ZIPファイルを解凍すれば結構です',
          'Pro版では、Windows　GDIの設定を変えるだけで、ZIPファイルを解凍して、Startup.exeを実行していただきたい',
          'アンインストールはそれぞれ同梱のDelete.exeまたはUnistall.exeを実行してください'
        ]
      }, {
        id: '11',
        question: '縦書きPDFの検索できますか',
        answer: [
          '縦書きPDFの検索が可能です',
          '下記の手順で実現が可能です。',
          '1) 縦書きPDFをサポートするメーカーサイトから使用条件を確認したうえ、下記IFILTERをインストールしてください。',
          '<a href="http://www.adobe.com/support/downloads/detail.jsp?ftpID=2611">http://www.adobe.com/support/downloads/detail.jsp?ftpID=2611</a>',
          '(WindowsXP以降で全文検索くんとの連動に問題ないと確認済み)',
          '2) 全文検索くんを起動していない状態を確認します。',
          '右下のトレー領域に全文検索くんのアイコンがないかCtrl+Shiftで全文検索くん の検索画面がでないかを確認します。アイコンがあるまたは Ctrl+Shiftで検索 画面が出たら、全文検索くんは 起動している状態で、まず、停止させてください。',
          '停止させる方法は、全文検索くんのメイン画面の左側の「その他機能」→「終 了」を押せば、停止できます',
          '3) 下記サンプルのように、全文検索くんのインストールフォルダーのtoolフォルダー下にあるconfig.xmlに下記の一行を追加します。',
          '&#60;IFilter.pdf&#62;1&#60;/IFilter.pdf&#62;',
          '4）インデックスを再作成していただければ、検索できるようになります。'
        ]
      },
      {
        id: '12',
        question: '複数台のPCをご利用していますが、ライセンスの共用が可能でしょうか',
        answer: [
          'すみませんですが、PC単位のライセンス形態です。',
          'ライセンスのシェアができないです',
          '複数台PCでのご利用であれば、台数分のライセンスキーが必要です'
        ]
      },
      {
        id: '13',
        question: '全文検索くんメーン画面に表示したホームページが古いようですが、どのようにすれば最新ページを表示できるでしょうか',
        answer: [
          'Windowsのコントロールパネルのインタネットオプション画面でヒストリ―を削除すれば、ローカルPCのキャシューがなくなり、最新版が表示できるようになります。'
        ]
      },
      {
        id: '14',
        question: '全文検索くんZIP版をダウンロードして実行して、インデックス作成もできて、検索も問題ないですが、OS再起動すると、全文検索くん再起動できない、どのようにすればいいでしょうか',
        answer: [
          '全文検索くんZIP版をダウンロードしたら、必ずフォルダを指定して展開してください。OSのデフォルト処理で、ダウンロードしたZIPファイルを開くことになります。そのままZIPファイル中のSearchplusplus.exeをクリックして実行できても、そのあと、OS再起動すると、一時ファイルは削除されて、ご利用できないです。なので、初心者に対して全文検索くんインストール版をご利用することを推薦します。'
        ]
      }
      ]
    }
  },
  methods: {
    getRowKeys (row) {
      return row.id
    },
    rowClick (row) {
      if (row.id === this.expands[0]) { // collapsed
        this.expands = []
      } else { // expand
        this.expands = []
        this.expands.push(row.id)
      }
    }
  }
}

</script>

<style scoped>
.el-table__header {
  width: 100% !important;
  /* width: 850px; */
}

.el-table__body {
  width: 100% !important;
  /* width: 850px; */
}
</style>
